import { SubscriptionItem } from "../types/subscriptionTypes";

export interface RecalculateItemPricePayload {
  responseData?: any;
  item: SubscriptionItem;
  newQuantity: number;
  taxRate: number | null;
  rowIndex: number;
}

export const processRecalculatedPrice = (payload: RecalculateItemPricePayload): SubscriptionItem | null => {
  const { responseData, item, newQuantity, taxRate } = payload;

  if (!responseData) {
    return null;
  }

  const calculatedItem = responseData.line_items?.find(
    (lineItem: any) => Number(lineItem.product_id) === Number(item.product_id)
  );

  if (!calculatedItem) {
    return null;
  }
  const newPrice = Number(calculatedItem.pricing.discounted_line_item_price || 0);
  const itemTax = calculatedItem.pricing.taxes || taxRate || 0;
  const newTax = itemTax * newPrice;
  const newTotal =
    calculatedItem.pricing.total ||
    calculatedItem.pricing.row_total ||
    Number((Number(newPrice) + Number(newTax)).toFixed(2));

  return {
    ...item,
    quantity: newQuantity,
    price: Number(newPrice),
    tax_amount: Number(newTax),
    row_total: Number(newTotal),
  };
};

export const calculateSubscriptionTotals = (details: SubscriptionItem[]) => {
  const totalTaxAmount = details.reduce(
    (prev: number, cur: SubscriptionItem) => Number(prev) + Number(cur.tax_amount || cur.taxAmount || 0),
    0
  );

  const totalPriceAmount = details.reduce(
    (prev: number, cur: SubscriptionItem) => Number(prev) + Number(+cur.price || 0),
    0
  );

  const totalOrderAmount = details.reduce(
    (prev: number, cur: SubscriptionItem) => Number(prev) + Number(cur.row_total || cur.total || cur.totalAmount || 0),
    0
  );

  return {
    taxAmount: totalTaxAmount.toFixed(2),
    amount: totalPriceAmount.toFixed(2),
    totalPrice: totalOrderAmount.toFixed(2),
    totalAmount: totalOrderAmount.toFixed(2),
  };
};
